/* eslint-disable */
import { memo } from 'react';
import { Modal, Image, Space, Typography, Button } from 'antd';
import { useTranslation } from 'translations';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { LINKS } from 'configuration';
import disableHistoricalStep1 from './assets/images/help/disableHistorical/disableHistorical_step1.png';
import disableHistoricalStep2 from './assets/images/help/disableHistorical/disableHistorical_step2.png';
import disableHistoricalStep3 from './assets/images/help/disableHistorical/disableHistorical_step3.png';

interface InstructionsModalProps {
  instructionsKey?: string;
  instructionsVisible: boolean;
  hideInstructions: (...args: any[]) => any;
}

const InstructionsModal = memo(
  ({ instructionsKey = undefined, instructionsVisible, hideInstructions }: InstructionsModalProps) => {
    const { t, tC } = useTranslation('components', 'guide');

    const instructions: Record<string, any> = {
      INSTRUCTIONS_DELETE_DEVICE: {
        title: 'deleteDevice.title',
        text: (
          <>
            <ol>
              <li>
                <Trans t={t} i18nKey="deleteDevice.step1">
                  Go to
                  <Link to={LINKS.devices} target="_blank" rel="noopener noreferrer">
                    IoT Devices
                  </Link>
                  and do the rest.
                </Trans>
              </li>
              <li>{t('deleteDevice.step2')}</li>
              <li>{t('deleteDevice.step3')}</li>
            </ol>
            {t('deleteDevice.warning')}
          </>
        ),
        imageSize: 600,
        preview: false,
        image: [],
      },
      INSTRUCTIONS_DISABLE_LOGS: {
        title: 'disableLogs.title',
        text: (
          <>
            <Trans t={t} i18nKey="disableLogs.text">
              go to
              <Link to={LINKS.devices} target="_blank" rel="noopener noreferrer">
                IoT Devices page
              </Link>
            </Trans>
            <ol>
              <li>{t('disableLogs.step1')}</li>
              <li>{t('disableLogs.step2')}</li>
              <li>{t('disableLogs.step3')}</li>
            </ol>
          </>
        ),
        imageSize: 200,
        preview: true,
        image: [
          disableHistoricalStep1,
          disableHistoricalStep2,
          disableHistoricalStep3,
        ],
      },
    };

    if (!instructionsKey || instructions[instructionsKey] === undefined) {
      return null;
    }

    return (
      <Modal
        open={instructionsVisible}
        onCancel={hideInstructions}
        title={tC(instructions[instructionsKey].title)}
        className="modal large"
        footer={
          <Button type="primary" onClick={hideInstructions}>
            {tC('okButton')}
          </Button>
        }>
        <Typography.Paragraph>{instructions[instructionsKey].text}</Typography.Paragraph>
        <Space>
          {instructions[instructionsKey].image.map((img: string, index: number) => (
            <Image
              key={index}
              alt="Instructions Modal Steps"
              preview={instructions[instructionsKey].preview}
              width={instructions[instructionsKey].imageSize}
              src={img}
            />
          ))}
        </Space>
      </Modal>
    );
  },
);

export default InstructionsModal;
